module.exports = __webpack_public_path__ + "img/pro_one_5.58e627f9.jpg";